/**
 * Determines if a value is true
 * @param v
 * @returns {boolean}
 */
import {isNumber} from "@/js/utilities/number/conditional";

export const isTrue = (v) =>
	v !== undefined
	&& v !== null
	&& (v === 1
		|| v === true
		|| v.toString().trim() === '1'
		|| v.toString().trim().toLowerCase() === 'true'
		|| ((typeof(v) === 'number' || isNumber(v)) && !isNaN(v) && v > 0));

/**
 * Determines if a value is false
 * @param v
 * @returns {boolean}
 */
export const isFalse = (v) =>
		v !== undefined
		&& v !== null
		&& (v === 0
			|| v === false
			|| v.toString().trim() === '0'
			|| v.toString().trim().toLowerCase() === 'false');